/* eslint-disable no-nested-ternary */

import styled from 'styled-components';

interface Props {
	$hasError?: boolean;
	$direction: 'rtl' | 'ltr';
}

export default styled.div<Props>`
	width: calc(100% - 20px);
	display: inline-block;
	margin: 10px;
	vertical-align: top;
	position: relative;
	#autocomplete-tag {
		position: absolute;
		bottom: 0;
		height: 49px;
		padding: 13px 17px;
		border: 0;
		background: transparent;
		font-weight: 500;
		color: #fff;
		opacity: 0.5;
		width: 50%;
		text-align: right;
	}
	.label {
		font-size: 14px;
		float: right;
		margin-bottom: 10px;
		font-weight: 500;
		color: #a2a2a2;
	}
	input {
		width: 100%;
		appearance: none;
		border-radius: 10px;
		padding: 13px 15px;
		font-weight: 500;
		border: 2px solid ${(props) => (props.$hasError ? '#fd1b1b' : '#222')};
		color: #fff;
		transition: all 200ms ease;
		direction: ${(props) => props.$direction || 'rtl'};
		background: #111;
		text-align: ${(props) =>
			props.$direction
				? props.$direction === 'rtl'
					? 'right'
					: 'left'
				: 'right'};
		&:focus {
			border: 2px solid #fff;
		}
		&:-webkit-autofill,
		&:-webkit-autofill:hover,
		&:-webkit-autofill:focus,
		&:-webkit-autofill:active {
			-webkit-box-shadow: 0 0 0 30px white inset !important;
		}
	}
	.error-message {
		color: #fd1b1b;
		font-size: 13px;
		width: 100%;
		display: block;
		margin-top: 10px;
		text-align: right;
	}
`;
